import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Model,
  Opts,
  PagedResponse,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
import { getValidationError } from "@ofqual/portal-core/core/utils/validationHelper";

export class KeywordService extends BaseRemoteService {
  public async add(keyword: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/lcm/keyword`;

    try {
      const response: Model = await super.postRequest(url, keyword, opts);

      const mappedData = {
        id: response.id,
        label: response.name,
      };

      return {
        ...response,
        data: mappedData,
      };
    } catch (err) {
      const validationError = getValidationError(err);
      if (validationError.isValidationError) {
        return { id: "-1", label: "Error on 204" };
      }
      throw err;
    }
  }

  public async get(id: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/lcm/keyword/${id.toString()}`;
    const response = await super.getRequest<Model>(url, opts);
    
    const mappedData = {
      id: response.id,
      label: response.name,
    };

    return {
      ...response,
      data: mappedData,
    };
  }

  public async search(
    params: QueryParams,
    opts?: Opts
  ): Promise<PagedResponse<Model>> {
    const mappedParams = { ...params, search: params.search || params.query };
    const url = `${this.apiRoot}/Lcm/keyword/${paramsToSearchString(
      mappedParams
    )}`;
    const response = await super.getRequest<PagedResponse<Model>>(url, opts);
    const mappedData = response.data.map((item) => ({
      id: item.id,
      label: item.name,
    }));
    return {
      ...response,
      data: mappedData,
    };
  }
}
